import React, { ReactNode } from 'react';

import { Divider } from '@mui/material';

import InBodyLogo from '../../../assets/image/inbody-logo-white.png';
import { ReactComponent as PoweredByLBIcon } from '../../../assets/image/powered-by-LB.svg';

import classes from './InBodyHederLogo.module.scss';

type InBodyHeaderLogoProps = {
  children: ReactNode;
};

const InBodyHeaderLogo = ({ children }: InBodyHeaderLogoProps) => {
  return (
    <div className={classes.container}>
      {children}
      <Divider orientation="vertical" className={classes.divider} />
      <div className={classes.logoBox}>
        <img src={InBodyLogo} alt="inbody" />
        <PoweredByLBIcon />
      </div>
    </div>
  );
};

export { InBodyHeaderLogo };
